module.exports = __webpack_public_path__ + "img/nacho.3510216f.png";